import {Controller} from '@hotwired/stimulus';
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'freemium-time-option-select'
    ];

    openModal(event) {
        event.preventDefault();
        this.freemiumTimeOptionSelectOutlet.openModal(event);
    }
}